import {
    OBTENER_USUARIO,
    LOGIN_EXITOSO,
    LOGIN_ERROR,
    CERRAR_SESION,
    LIMPIAR_ERROR,
} from "./authActions";

const authReducer = (state, action) => {
    switch (action.type) {

        case LOGIN_EXITOSO:
            return {
                ...state,
                autenticado: true,
                token: action.payload.token,
                mensaje: null,
                cargando: false
            }

        case CERRAR_SESION:
            return {
                ...state,
                token: null,
                autenticado: false,
                usuario: null,
                cargando: false,
                mensaje: action.payload
            }

        case LOGIN_ERROR:
            return {
                ...state,
                mensaje: action.payload.msg
            }

        case LIMPIAR_ERROR: {
            return {
                ...state,
                token: null,
                mensaje: null,
                autenticado: false,
                usuario: null,
                cargando: false
            }
        }

        case OBTENER_USUARIO:
            return {
                ...state,
                usuario: action.payload,
                autenticado: true,
                cargando: false
            }

        default:
            return state;
    }
}

export default authReducer;
